import { cloneDeep } from 'lodash';
export class CommandHistoryModel {
    constructor({ canvasId, initCanvasData, canvasModel, }) {
        this.maxHistoryLength = 10;
        this.canvasId = canvasId;
        this.commandStack = [cloneDeep(initCanvasData)];
        this.canvasModel = canvasModel;
        this.historyPointer = 0;
    }
    /** 记录历史 */
    pushHistoryRecord(canvasData) {
        if (this.commandStack.length > this.maxHistoryLength &&
            this.historyPointer === this.commandStack.length - 1) {
            this.commandStack.splice(1, 1);
            this.historyPointer = this.commandStack.length - 1;
        }
        const { commandStack, historyPointer } = this;
        this.commandStack = commandStack.slice(0, historyPointer + 1);
        this.commandStack.push(cloneDeep(canvasData));
        this.historyPointer++;
    }
    // 取出历史
    dispatchRedoCanvasData() {
        if (this.couldRedoCommand) {
            const newPointer = ++this.historyPointer;
            return this.commandStack[newPointer];
        }
    }
    // 取出历史
    dispatchUndoCanvasData() {
        if (this.couldUndoCommand) {
            const newPointer = --this.historyPointer;
            return this.commandStack[newPointer];
        }
    }
    resetCommandHistory() {
        this.commandStack = [cloneDeep(this.canvasModel.getCanvasData())];
        this.historyPointer = 0;
    }
    get couldRedoCommand() {
        return this.historyPointer < this.commandStack.length - 1;
    }
    get couldUndoCommand() {
        return this.historyPointer !== 0;
    }
}
//# sourceMappingURL=command-history.js.map